/** Values that are available about the users location. */
export interface GeoLocation {
  /** ISO 3166-1 alpha-2. 'ZZ' when unknown */
  country: string;
  regionSubdivision: string;
  /** Lower-case like 'ca' or 'tx'. 'na' when unknown */
  region: string;
}
